import type { Translations } from './en';
const appName = process.env.NEXT_PUBLIC_APP_NAME || 'MyApp';
const pt: Translations = {
  common: {
    appName: appName,
    loading: 'Carregando...',
    save: 'Salvar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    delete: 'Excluir',
    edit: 'Editar',
    back: 'Voltar',
    search: 'Pesquisar',
    noResults: 'Nenhum resultado encontrado',
    error: 'Ocorreu um erro',
    success: 'Sucesso',
  },
  header: {
    searchPlaceholder: 'Pesquisar cosers, hotgirls, ao dai, modelos...',
    searchPlaceholderMobile: 'Pesquisar...',
    home: 'Início',
    hotgirl: 'Hotgirl',
    coser: 'Coser',
    model: 'Modelo',
    upload: 'Enviar',
    notifications: 'Notificações',
    login: 'Entrar',
    register: 'Cadastrar',
  },
  footer: {
    tagline: `A melhor plataforma para compartilhar fotos de Coser, Hotgirl e Modelos no ${appName}.`,
    copyright: `© {year} ${appName}. Todos os direitos reservados.`,
    sections: {
      explore: 'Explorar',
      account: 'Conta',
      support: 'Suporte',
    },
    links: {
      home: 'Início',
      hotgirl: 'Hotgirl',
      coser: 'Coser',
      model: 'Modelo',
      aoDai: 'Ao Dai',
      login: 'Entrar',
      register: 'Cadastrar',
      upload: 'Enviar Foto',
      dashboard: 'Painel',
      terms: 'Termos de Serviço',
      privacy: 'Política de Privacidade',
      report: 'Reportar Violação',
      contact: 'Contato',
    },
  },
  collections: {
    title: 'Coleções',
    createAlbum: 'Criar Álbum',
    saved: 'Salvos',
    noSaved: 'Nenhuma foto salva ainda',
    noSavedHint: 'Explorar fotos agora →',
    removedSave: 'Removido dos salvos',
    createModalTitle: 'Criar novo álbum',
    albumNamePlaceholder: 'Nome do álbum...',
    cancel: 'Cancelar',
    create: 'Criar',
    albumCreated: 'Álbum criado',
  },
  home: {
    title: 'Descubra a',
    titleHighlight: 'beleza',
    titleSuffix: 'da vida',
    subtitle: 'Milhares de fotos de Coser, Hotgirl e Modelos atualizadas todos os dias',
    sortNewest: 'Mais Recentes',
    sortTrending: 'Em Alta',
    sortPopular: 'Populares',
    allCategories: 'Todos',
    noMorePosts: 'Você viu todas as fotos',
  },
  auth: {
    login: {
      title: 'Entre para continuar',
      continueWithGoogle: 'Continuar com o Google',
      orLoginWithEmail: 'ou entre com e-mail',
      email: 'E-mail',
      password: 'Senha',
      forgotPassword: 'Esqueceu a senha?',
      submitButton: 'Entrar',
      loading: 'Entrando...',
      noAccount: 'Não tem uma conta?',
      registerLink: 'Cadastre-se agora',
      errorCredentials: 'E-mail ou senha incorretos',
      successLogin: 'Entrou com sucesso!',
    },
    register: {
      title: 'Crie uma conta grátis',
      displayName: 'Nome de Exibição',
      displayNamePlaceholder: 'João Silva',
      email: 'E-mail',
      password: 'Senha',
      passwordPlaceholder: 'Mínimo 8 caracteres',
      confirmPassword: 'Confirmar Senha',
      submitButton: 'Cadastrar',
      loading: 'Criando conta...',
      hasAccount: 'Já tem uma conta?',
      loginLink: 'Entrar',
      errorPasswordMismatch: 'As senhas não coincidem',
      errorPasswordLength: 'A senha deve ter pelo menos 8 caracteres',
      errorGeneric: 'Falha no cadastro',
      successRegister: 'Conta criada com sucesso!',
      emailTaken: 'E-mail já está em uso',
      serverError: 'Erro no servidor, tente novamente mais tarde',
    },
    forgotPassword: {
      title: 'Esqueceu a senha',
      subtitle: 'Digite seu e-mail e enviaremos um link de redefinição',
      email: 'E-mail',
      submitButton: 'Enviar Link de Redefinição',
      backToLogin: 'Voltar para o login',
      sending: 'Enviando...',
      emailSent: 'E-mail enviado!',
      checkEmail: 'Verifique a caixa de entrada de {email} para o link de redefinição de senha.',
      instructions: 'Digite seu e-mail e enviaremos um link para redefinir sua senha.',
    },
  },
  userMenu: {
    dashboard: 'Painel',
    collections: 'Coleções',
    settings: 'Configurações',
    logout: 'Sair',
  },
  settings: {
    title: 'Configurações da Conta',
    profile: {
      nav: 'Perfil',
      title: 'Informações do Perfil',
      displayName: 'Nome de Exibição',
      username: 'Nome de Usuário',
      website: 'Site',
      bio: 'Bio',
      bioPlaceholder: 'Apresente-se...',
      changeAvatar: 'Alterar Avatar',
      avatarHint: 'JPG, PNG, WebP máx. 5MB',
      saveButton: 'Salvar Alterações',
      saving: 'Salvando...',
      savedSuccess: 'Alterações salvas',
    },
    password: {
      nav: 'Senha',
      title: 'Alterar Senha',
      fields: {
        currentPassword: 'Senha Atual',
        newPassword: 'Nova Senha',
        confirm: 'Confirmar Nova Senha',
      },
      errors: {
        confirm: 'As novas senhas não coincidem',
        minLength: 'A senha deve ter pelo menos 8 caracteres',
      },
      success: 'Senha alterada com sucesso!',
      saving: 'Salvando...',
      submit: 'Alterar Senha',
    },
    notifications: {
      nav: 'Notificações',
      title: 'Configurações de Notificações',
      options: {
        likes: 'Quando alguém curtir sua foto',
        comments: 'Quando alguém comentar',
        replies: 'Quando alguém responder seu comentário',
        follows: 'Quando alguém seguir você',
        approved: 'Quando a publicação for aprovada',
        email_digest: 'Resumo semanal por e-mail',
        marketing: 'Notificações promocionais e de eventos',
      },
      saveSuccess: 'Configurações de notificações salvas',
      saving: 'Salvando...',
      saveButton: 'Salvar Configurações',
    },
    security: {
      nav: 'Segurança',
      twoFactorAuth: 'Autenticação de Dois Fatores (2FA)',
      twoFactorAuthHint: 'Aumente a segurança com um código de verificação do aplicativo',
      comingSoon: 'Em Breve',
      activeSessions: 'Sessões Ativas',
      currentBrowser: 'Navegador Atual',
      lastLogin: 'Último Login',
      active: 'Ativo',
      dangerZone: 'Zona de Perigo',
      deleteAccountHint: 'Excluir sua conta removerá permanentemente todos os seus dados.',
      deleteAccount: 'Excluir Conta',
    },
  },
  post: {
    likes: '{count} curtidas',
    views: '{count} visualizações',
    shares: '{count} compartilhamentos',
    comments: '{count} comentários',
    save: 'Salvar',
    saved: 'Salvo',
    share: 'Compartilhar',
    linkCopied: 'Link copiado!',
    follow: 'Seguir',
    following: 'Seguindo',
    relatedPosts: 'Publicações Relacionadas',
    commentPlaceholder: 'Escrever um comentário...',
    commentLoginPlaceholder: 'Entre para comentar...',
    commentSubmit: 'Publicar',
    commentSubmitting: 'Publicando...',
    noComments: 'Nenhum comentário ainda. Seja o primeiro!',
    savedToCollection: 'Salvo na coleção',
    removedFromCollection: 'Removido da coleção',
    description: 'Descrição',
    profileView: 'Ver perfil',
  },
  notifications: {
    title: 'Notificações',
    empty: 'Sem notificações',
    markAllRead: 'Marcar todas como lidas',
    types: {
      like_post: 'curtiu sua foto',
      comment: 'comentou na sua foto',
      reply: 'respondeu seu comentário',
      follow: 'seguiu você',
      approve: 'sua publicação foi aprovada',
      reject: 'sua publicação foi rejeitada',
      system: 'notificação do sistema',
    },
  },
  search: {
    title: 'Resultados para',
    result: 'Resultados',
    tryOtherKeywords: 'Tente outras palavras-chave...',
    noResults: 'Nenhum resultado para',
    placeholder: 'Pesquisar...',
    thisHashtag: 'fotos com esta hashtag',
  },
  upload: {
    title: 'Enviar Foto',
    dragDrop: 'Arraste e solte ou clique para selecionar',
    supportedFormats: 'Suporta JPG, PNG, WebP, GIF',
    submit: 'Publicar',
    submitting: 'Publicando...',
    titleField: 'Título',
    titlePlaceholder: 'Digite um título atraente...',
    descriptionField: 'Descrição',
    descriptionPlaceholder: 'Descrição detalhada do conjunto de fotos...',
    hashtagsField: 'Hashtags',
    statusField: 'Status',
    statusPublic: 'Público',
    statusPrivate: 'Privado',
    statusDraft: 'Rascunho',
    error: 'Erro ao enviar',
    errorSelect: 'Selecione pelo menos 1 foto',
    errorTitle: 'Digite um título',
    photos: 'fotos',
    uploading: 'Enviando...',
  },
  notFound: {
    title: 'Página não encontrada',
    subtitle: 'A página que você está procurando não existe.',
    backHome: 'Voltar ao Início',
  },
  liked: {
    title: 'Publicações Curtidas',
    empty: 'Você ainda não curtiu nenhuma publicação.',
  },
  user: {
    unknown: 'Desconhecido',
  },
  globalError: {
    title: 'Ocorreu um erro',
    subtitle: 'Desculpe o inconveniente. Por favor, tente novamente.',
    retry: 'Tentar Novamente',
  },
  username: {
    posts: 'Publicações',
    likes: 'Curtidas',
    followers: 'Seguidores',
    following: 'Seguindo',
    editProfile: 'Editar Perfil',
    message: 'Mensagem',
    noPosts: 'Nenhuma publicação ainda.',
    bio: 'Ver fotos de ',
    notFound: 'Usuário não encontrado',
  },
  topic: {
    notFound: 'Tópico não encontrado',
    viewTitle: 'Ver tópico ',
  },
  dashboard: {
    title: 'Painel',
    welcome: 'Olá',
    stats: {
      posts: 'Publicações',
      views: 'Visualizações',
      likes: 'Curtidas',
      comments: 'Comentários',
    },
  },
  adsblock: {
    title: 'Você está usando AdBlock',
    description: 'Desative o AdBlock para ver imagens de alta qualidade e nos ajudar a manter o site gratuito.',
    action: 'Já desativei — Recarregar',
    cancel: 'Pular',
  },
  pwa: {
    title: `Instale o ${appName} para uma experiência melhor!`,
    iosSubtitle: `Pressione Compartilhar → Adicionar à Tela Inicial`,
    androidSubtitle: `Receba notificações sobre novos conjuntos de fotos assim que forem lançados`,
    installButton: `Instalar ${appName}`,
    disclaimer: `Instalação rápida, sem necessidade de loja de aplicativos.`,
  },
  autotrans: {
    title: 'Tradução automática',
    translated: 'Tradução',
    origin: 'Conteúdo original',
  },
  subscription: {
    title: 'Inscrever-se em Notificações',
    description: 'Receba notificações sobre novos conjuntos de fotos assim que forem lançados.',
    subscribeButton: 'Inscrever-se',
    unsubscribeButton: 'Cancelar Inscrição',
    subscribed: 'Você está inscrito em notificações.',
    unsubscribed: 'Você cancelou a inscrição em notificações.',
    error: 'Ocorreu um erro ao atualizar sua inscrição. Por favor, tente novamente.',
    success_tit: '🎉 Notificações Ativadas!',
    denied_tit: 'Notificações Negadas',
    error_tit: 'Ocorreu um Erro',
    success_des: 'Você receberá notificações quando novos conteúdos estiverem disponíveis.',
    denied_des: 'Você pode reativá-las nas configurações do seu navegador.',
    error_des: 'Por favor, tente novamente mais tarde.',
    skip: 'Pular',
    processing: 'Processando...',
    noti: 'Ativar Notificações',
    rule: 'Mostrar apenas notificações para novos conteúdos.',
    notify_title: `Notificações - ${appName}`,
    notify_body: "A nova galeria foi lançada. Confira agora!",
  },
  contact: {
    title: 'Entre em Contato',
    subtitle: 'Adoraríamos ouvir de você! Por favor, preencha o formulário abaixo e entraremos em contato assim que possível.',
    name: 'Nome',
    email: 'Email',
    subject: 'Assunto',
    message: 'Mensagem',
    submitButton: 'Enviar Mensagem',
    sending: 'Enviando...',
    successTitle: 'Mensagem Enviada!',
    successMessage: 'Obrigado por entrar em contato. Retornaremos em breve.',
    errorTitle: 'Ocorreu um erro',
    errorMessage: 'Ocorreu um erro ao enviar sua mensagem. Por favor, tente novamente mais tarde.',
    res_time_title: 'Tempo de resposta',
    res_time: 'Normalmente respondemos dentro de 1 a 3 dias úteis.',
    report_content: 'Reportar Conteúdo',
    report_content_hint: 'Para reportar um post ou usuário, use o botão de reportar diretamente no conteúdo ou selecione “Reportar conteúdo” acima.',
    value_default: 'Selecione um tópico',
    value_general: 'Consulta geral',
    value_report: 'Reportar conteúdo',
    value_account: 'Problema de conta',
    value_business: 'Negócios / parceria',
    value_feedback: 'Feedback & sugestões',
    value_other: 'Outro'
  },
  language: {
    label: `Idioma`,
    en: `English`,
    vi: `Tiếng Việt`,
    zh: `中文`,
    ja: `日本語`,
    ko: `한국어`,
    ar: `العربية`,
    fr: `Français`,
    es: `Español`,
    ru: `Русский`,
    hi: `हिन्दी`,
    id: `Indonesia`,
    de: `Deutsch`,
    pt: `Português`,
    it: `Italiano`,
  },
} as const;

export default pt;